<template>
  <div v-if="sites.length" class="psu">
    <div class="psu-top">
      <h3>Sites AI used most</h3>
      <a href="#" @click.prevent="$emit('go-to-tab', 'sources')">See all in Sources &rarr;</a>
    </div>
    <div class="psu-grid">
      <div v-for="s in sites" :key="s.site" class="psu-card">
        <strong>{{ s.site }}</strong>
        <span>Cited in {{ s.cited_in }} of {{ s.of }} answers</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProviderSitesUsed',
  props: { sites: { type: Array, default: () => [] } },
  emits: ['go-to-tab']
}
</script>

<style scoped>
.psu { border-top: 1px solid #ece7da; padding-top: 18px; display: flex; flex-direction: column; gap: 12px; }
.psu-top { display: flex; flex-wrap: wrap; justify-content: space-between; align-items: baseline; gap: 8px; }
.psu h3 { margin: 0; font-size: 17px; font-weight: 700; }
.psu a { font-size: 14px; font-weight: 600; color: var(--brand-ocean-600); }
.psu-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 10px; }
.psu-card { border: 1px solid #e6e1d4; background: var(--brand-sand-50); border-radius: 10px; padding: 12px 14px; display: flex; flex-direction: column; gap: 6px; }
.psu-card strong { font-size: 15px; }
.psu-card span { font-size: 13px; color: #4a5568; }
</style>
